import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import { AuthStore } from "stores/AuthStore";
import { useStore } from "utils/useStore";

const ImpersonationBanner = observer(() => {
    const authStore = useStore(AuthStore);

    if (!authStore.isImpersonating || !authStore.impersonationState) {
        return null;
    }

    const { actualUser, effectiveUser } = authStore.impersonationState;
    const targetLabel =
        [effectiveUser?.firstName, effectiveUser?.lastName]
            .filter(Boolean)
            .join(" ")
            .trim() || effectiveUser?.userName;
    const actualLabel =
        [actualUser?.firstName, actualUser?.lastName]
            .filter(Boolean)
            .join(" ")
            .trim() || actualUser?.userName;

    return (
        <Box sx={{ px: 2, pt: 1 }}>
            <Alert
                severity="warning"
                action={
                    <Button
                        color="inherit"
                        size="small"
                        onClick={() => authStore.stopImpersonating()}
                    >
                        Stop
                    </Button>
                }
            >
                <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap">
                    <Typography variant="body2" fontWeight={700}>
                        Impersonating {targetLabel}
                    </Typography>
                    <Typography variant="body2">
                        Actions continue to originate from {actualLabel}.
                    </Typography>
                </Stack>
            </Alert>
        </Box>
    );
});

export default ImpersonationBanner;
